export default {
    'grapesjs-project-manager': {
        templates: {
            all: 'All',
            templates: 'Templates',
            search: 'Search for sites by name or id',
            open: 'Open',
            new: 'Enter new page name',
            create: 'Create',
            help: 'Select a template, enter project name, then click create. If no template is selected a blank project will be created.',
            info: 'Site Info',
            updated: 'Last Updated',
            pages: 'Pages',
            created: 'Created At',
            size: 'Size',
            actions: 'Actions',
            titles: {
                open: 'Select to open site',
                info: 'Click to sort by site name',
                updated: 'Click to sort by last update date',
                pages: 'Click to sort by number of pages',
                created: 'Click to sort by site creation date',
                size: 'Click to sort by site size',
                actions: 'Click to sort by site name',
                delete: 'Delete',
                edit: 'Edit',
            }
        },
        pages: {
            placeholder: 'page name',
            new: 'New Page +',
        },
        settings: {
            save: 'Save',
            generate: 'Generate',
            help: 'Enter url, or generate thumbnail.',
            labels: {
                name: 'Name',
                thumbnail: 'Thumbnail',
                description: 'Description',
                template: 'Template'
            },
            placeholders: {
                name: 'Name...',
                thumbnail: 'Thumbnail...',
                description: 'Description...',
            },
        },
    }
}